import { render } from "./WelcomeView.vue?vue&type=template&id=f3507346&scoped=true"
import script from "./WelcomeView.vue?vue&type=script&lang=js"
export * from "./WelcomeView.vue?vue&type=script&lang=js"

import "./WelcomeView.vue?vue&type=style&index=0&id=f3507346&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3507346"]])

export default __exports__